module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsValentine@2x.27967c1.webp";